import { render } from "./add-categories.vue?vue&type=template&id=058bbff0"
import script from "./add-categories.vue?vue&type=script&lang=js"
export * from "./add-categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__